'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchCatalogItemsIfNeeded = exports.LOAD_CATALOG_ITEMS_SUCCESS = exports.LOAD_CATALOG_ITEMS_REQUEST = exports.LOAD_CATALOG_ITEMS_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _fetchBatch = require('../modules/fetchBatch');

var _api = require('../api');

var _user = require('../modules/user');

var _config = require('../modules/config');

var _item = require('../modules/item');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_SET_SIZE = 1;

/* Action Types */
var LOAD_CATALOG_ITEMS_FAIL = exports.LOAD_CATALOG_ITEMS_FAIL = 'la/domain/catalogItems/LOAD_FAIL';
var LOAD_CATALOG_ITEMS_REQUEST = exports.LOAD_CATALOG_ITEMS_REQUEST = 'la/domain/catalogItems/LOAD_REQUEST';
var LOAD_CATALOG_ITEMS_SUCCESS = exports.LOAD_CATALOG_ITEMS_SUCCESS = 'la/domain/catalogItems/LOAD_SUCCESS';

/* ACTION CREATORS */
var loadCatalogItemsFail = function loadCatalogItemsFail(catalogId, error) {
    return {
        error: true,
        meta: { catalogId: catalogId },
        payload: error,
        type: LOAD_CATALOG_ITEMS_FAIL
    };
};

var loadCatalogItemsRequest = function loadCatalogItemsRequest(catalogId) {
    return {
        meta: { actionTime: Date.now() },
        payload: catalogId,
        type: LOAD_CATALOG_ITEMS_REQUEST
    };
};

// TODO: this function takes in catalogId, but others take catalogIds
var loadCatalogItemsSuccess = function loadCatalogItemsSuccess(catalogId, results) {
    return {
        meta: { actionTime: Date.now(), catalogId: catalogId },
        payload: results,
        type: LOAD_CATALOG_ITEMS_SUCCESS
    };
};

var loadCatalogItems = function loadCatalogItems(catalogIds, loadingId, cursor, page, count, itemId) {
    return function (dispatch, getState) {
        var state = getState();
        var authToken = (0, _user.getAuthToken)(state);
        var deployment = (0, _config.getDeployment)(state);
        dispatch(loadCatalogItemsRequest(catalogIds));
        return _api.Catalog.postCatalogItems({ authToken: authToken, catalogIds: catalogIds, count: count, cursor: cursor, deployment: deployment, itemId: itemId, page: page }).then(function (response) {
            return dispatch(loadCatalogItemsSuccess(catalogIds, response.data));
        }).catch(function (error) {
            dispatch(loadCatalogItemsFail(catalogIds, error));
            dispatch((0, _fetchBatch.loadBatchEnd)(loadingId));
        });
    };
};

var loadCatalogItemsInSets = function loadCatalogItemsInSets(ids, setSize, loadingId, cursor, page, count, itemId) {
    return function (dispatch) {
        if (global.__SERVER__) {
            return dispatch(loadCatalogItems(ids, loadingId, cursor, page, count)).then(function () {
                return dispatch((0, _fetchBatch.loadBatchEnd)(loadingId));
            });
        }
        var promises = [];
        while (ids.length > 0) {
            promises.push(dispatch(loadCatalogItems(ids.splice(0, setSize), loadingId, cursor, page, count, itemId)));
        }
        return _promise2.default.all(promises).then(function () {
            return dispatch((0, _fetchBatch.loadBatchEnd)(loadingId));
        });
    };
};

var fetchCatalogItemsIfNeeded = exports.fetchCatalogItemsIfNeeded = function fetchCatalogItemsIfNeeded(catalogIds) {
    var loadingId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
    var cursor = arguments[2];
    var page = arguments[3];
    var count = arguments[4];
    var itemId = arguments[5];

    return function (dispatch, getState) {
        var needed = (0, _item.whichCatalogItemsNeeded)(getState(), catalogIds);
        if (needed.length) {
            dispatch((0, _fetchBatch.loadBatchStart)(loadingId));
            return dispatch(loadCatalogItemsInSets(needed, FETCH_SET_SIZE, loadingId, cursor, page, count, itemId));
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/catalogItems.js
// module id = ozIy
// module chunks = 46